import { createContext, useContext, useReducer, ReactNode, Dispatch } from 'react'
import { Toast } from '../../types/toast'

export type ToastAction = {
	type: string,
	payload: Toast,
}

export type ToastDispatchType = Dispatch<ToastAction>

const ToastStateContext = createContext<Toast[]>( [] )
const ToastDispatchContext = createContext<ToastDispatchType>( () => {} )

export function toastReducer( _state: Toast[], action: ToastAction ) {
	const { type, payload } = action

	switch ( type ) {
		case 'addToast':
			return [
				..._state,
				payload
			]
		case 'removeToast':
			return _state.filter( ( toast: Toast ) => toast.id !== payload.id )
		default:
			throw new Error( `ToastProvider unhandled action ${action.type}` )
	}
}

export function useToastState() {
	const state = useContext( ToastStateContext )

	if ( state === undefined ) {
		throw new Error( 'useToastState must be used within a ModalProvider' )
	}

	return state
}

export function useToastDispatch() {
	const dispatch = useContext( ToastDispatchContext )

	if ( dispatch === undefined ) {
		throw new Error( 'useToastDispatch must be used within a ModalProvider' )
	}

	return dispatch
}

export type ToastProviderProps = {
	children: ReactNode,
}

export function ToastProvider( { children }: ToastProviderProps ) {
	const [ state, dispatch ] = useReducer( toastReducer, [] )
	return (
		<ToastDispatchContext.Provider value={dispatch}>
			<ToastStateContext.Provider value={state}>
				{children}
			</ToastStateContext.Provider>
		</ToastDispatchContext.Provider>
	)
}
